import { ajax } from '../index'

/**
 * reset password相关接口
 */
export default {
  // 发起重置密码邮件
  forgotPassword(dataObj: any) {
    return ajax.post('api', `/api/v1/customer/forgot-password`, dataObj)
  },

  // 重置密码
  resetPassword(dataObj: any) {
    return ajax.post('api', `/api/v1/customer/reset-password`, dataObj)
  }
}